import React from 'react';
import { TemplateDTO } from 'dto/template';
import { PackagingType } from 'dto/package';
import ListItemDropdownContainer from '../ListItemDropdownContainer';
import PackageListItem from '../PackageListItem';
import SingleInstrumentListItem from '../SingleInstrumentListItem';
import './TemplateListItem.css';

interface Props {
  template: TemplateDTO;
  filterListBy?: string;
}

const TemplateListItem = ({ template, filterListBy }: Props) => {
  const renderList = () => (
    <div style={{ display: 'block' }} className="content_holder no_padding padding_left in_matlist lvl_1 packages-list">
      {template.packages.map(packageItem => {
        if (packageItem.packagingType === PackagingType.Single) {
          return <SingleInstrumentListItem singleInstrument={packageItem} key={packageItem.packageId} filterListBy={filterListBy} />;
        }
        return <PackageListItem packageItem={packageItem} key={packageItem.packageId} filterListBy={filterListBy} />;
      })}
    </div>
  );
  return (
    <ListItemDropdownContainer list={renderList()} classPrefix="template">
      <div className="image_wrapper_50">
        <div className="image_border white image-border" />
        <img src="images/icon_layer.jpg" alt="" className="image_circle_50" />
      </div>
      <div className="material_info">
        <div className="material_text">
          <div>{template.name}</div>
        </div>
      </div>
    </ListItemDropdownContainer>
  );
};

export default TemplateListItem;
